<template>
  <i :class="rbClass | toLowerCase"></i>
</template>

<script>
export default {
  name: 'RbIcon',
  props: {
    icon: {
      type: [String],
      required: true
    },
    size: {
      type: [Number, String],
      required: false,
      default: () => 1
    },
    sfxClass: {
      type: [String],
      required: false,
      default: () => ''
    }
  },
  data () {
    return {
      rbClass: 'rb rb-' + this.icon + ' rb-' + this.size + ' ' + this.sfxClass
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables/variables.scss";
$rb-font-folder: '#{$font-cdn}/v23';

@font-face {
  font-family: 'rb';
  src:    url('#{$rb-font-folder}/rb.eot');
  src:    url('#{$rb-font-folder}/rb.eot#iefix') format('embedded-opentype'),
      url('#{$rb-font-folder}/rb.woff2') format('woff2'),
      url('#{$rb-font-folder}/rb.ttf') format('truetype'),
      url('#{$rb-font-folder}/rb.woff') format('woff'),
      url('#{$rb-font-folder}/rb.svg#rb') format('svg');
  font-weight: normal;
  font-style: normal;
}

.rb, [class^="rb-"], [class*="rb-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'rb' !important;
  speak: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  text-decoration: none;

  display: inline-block; // Required for animations to work
  vertical-align: middle; // Risky, but aligns better after some testing.

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

// .rb-1 {
//   font-size: 1rem;
// }

// .rb-2 {
//   font-size: 1.5rem;
// }

// .rb-3 {
//   font-size: 2rem;
// }

// .rb-4 {
//   font-size: 2.5rem;
// }

// .rb-5 {
//   font-size: 3rem;
// }

// .rb-6 {
//   font-size: 3.5rem;
// }

// .rb-7 {
//   font-size: 4rem;
// }

@import "@/assets/styles/rb-icons/classes.scss";

</style>



// WEBPACK FOOTER //
// src/components/RbIcon.vue